import * as Path from './path.js';
class ToAlgebra extends Path.PathVisitor {
    visitAlternativePath({ paths }) {
        return {
            type: 'path',
            pathType: '|',
            items: paths.map(path => path.accept(this)),
        };
    }
    visitInversePath({ path: inversed }) {
        return {
            type: 'path',
            pathType: '^',
            items: [inversed.accept(this)],
        };
    }
    visitOneOrMorePath({ path: inner }) {
        return {
            type: 'path',
            pathType: '+',
            items: [inner.accept(this)],
        };
    }
    visitPredicatePath({ term: predicate }) {
        return predicate;
    }
    visitSequencePath({ paths }) {
        return {
            type: 'path',
            pathType: '/',
            items: paths.map(path => path.accept(this)),
        };
    }
    visitZeroOrMorePath({ path: inner }) {
        return {
            type: 'path',
            pathType: '*',
            items: [inner.accept(this)],
        };
    }
    visitZeroOrOnePath(path) {
        return {
            type: 'path',
            pathType: '?',
            items: [path.path.accept(this)],
        };
    }
}
/**
 * Creates a sparqljs object which represents a SHACL path as Property Path
 *
 * @param path SHACL Property Path
 */
export function toAlgebra(path) {
    const visitor = new ToAlgebra();
    return visitor.visit(Path.fromNode(path));
}
//# sourceMappingURL=toAlgebra.js.map